"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

var _useRunningArchives = require('../useRunningArchives');

const DISMISSED_KEY = 'directory.patientImport.dismissed'

const readDismissed = () => {
  try {
    // SAFETY: written by this module.
    return window.localStorage.getItem(DISMISSED_KEY) 
  } catch (e) {
    return null
  }
}

/* The org's latest Directory import, for its progress bar and result line
 * in the archive bar's place (b1-6, b1-7, b1-8). It reads the import's status
 * as the tab opens, every two seconds while one runs, and once a minute
 * otherwise, as archives are polled. onFinished runs once when an import
 * this page watched running ends. Only admins ask (D-101). */
 const useDirectoryImport = ({ orgKey, isEnabled, onFinished }



) => {
  const [status, setStatus] = _react.useState(null)
  // The × on a result line hides it for this browser (a convenience).
  const [dismissed, setDismissed] = _react.useState(readDismissed)
  const runningRef = _react.useRef(null)
  const onFinishedRef = _react.useRef.call(void 0, onFinished)
  _react.useLayoutEffect.call(void 0, () => { onFinishedRef.current = onFinished })

  const accept = _react.useCallback.call(void 0, (next) => {
    setStatus(next)
    if (_optionalChain([next, 'optionalAccess', _ => _.State]) === 'running') {
      runningRef.current = next.TaskKey
    } else if (runningRef.current && next && runningRef.current === next.TaskKey) {
      runningRef.current = null
      onFinishedRef.current(next)
    }
  }, [])

  const [tick, setTick] = _react.useState.call(void 0, 0)
  const isRunning = _optionalChain([status, 'optionalAccess', _2 => _2.State]) === 'running'
  _react.useEffect.call(void 0, 
    () => {
      if (!isEnabled) return
      let isCurrent = true
      _actions2.default.getDirectoryImportStatus({ OrgKey: orgKey })
        .then(r => { if (isCurrent) accept(r.Import) })
        .catch(() => undefined)
      const timer = setTimeout(() => setTick(n => n + 1), isRunning ? _useRunningArchives.POLL_MS : _useRunningArchives.IDLE_POLL_MS)
      return () => {
        isCurrent = false
        clearTimeout(timer)
      }
    },
    [orgKey, isEnabled, isRunning, tick, accept],
  )

  // An import this page started shows at once, and is watched to its end.
  const started = _react.useCallback.call(void 0, (next) => accept(next), [accept])

  const dismiss = _react.useCallback.call(void 0, () => {
    if (!status) return
    setDismissed(status.TaskKey)
    try {
      window.localStorage.setItem(DISMISSED_KEY, status.TaskKey)
    } catch (e2) {
      // Hiding it is a convenience; it still goes for this visit.
    }
  }, [status])

  const shown = status && (status.State === 'running' || status.TaskKey !== dismissed) ? status : null
  return { status: shown, started, dismiss }
}; exports.useDirectoryImport = useDirectoryImport
